import React from 'react'
import Table from 'react-data-table-component';
import FilterComponent from './FilterComponent';

import { FaRegTrashAlt } from 'react-icons/fa';
import { FiEdit } from 'react-icons/fi';
import PropsTypes from 'prop-types';
import { info } from '../../assets/img/import';

const Datatable = props => {

  const { create, loading } = props;

  const [filterText, setFilterText] = React.useState("");

  const [resetPaginationToggle, setResetPaginationToggle] = React.useState(
    false
  );

  const filteredItems = React.useMemo(
    () =>
      props.data.filter((item) => {
        return JSON.stringify(item).toLocaleLowerCase().includes(filterText.toLocaleLowerCase());
      }),
    [props.data, filterText]
  );

  const subHeaderComponent = React.useMemo(() => {

    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={e => setFilterText(e.target.value)}
        onClear={handleClear}
        create={create}
        filterText={filterText}
      />
    );
  }, [filterText, resetPaginationToggle, create]);

  return (
    <Table
      columns={
        props.columns.concat({
          name: "Buttons",
          button: true,
          cell: row =>
            !row.showButtons ? (
              <>
                <a
                  href="/#"
                  className='bg-primary p-2 text-white rounded'
                  onClick={(e) => { e.preventDefault(); props.update(row.id) }}
                >
                  <FiEdit style={{ fontSize: 18 }} />
                </a>
                <div style={{ margin: '2px' }} />
                <a
                  href="/#"
                  className='bg-danger text-white rounded p-2'
                  onClick={(e) => { e.preventDefault(); props.delete(row.id) }}>
                  <FaRegTrashAlt style={{ fontSize: 18 }} />
                </a>
              </>
            ) : null
        })
      }
      data={filteredItems}
      defaultSortField="n ame"
      striped
      noDataComponent={
        <span className="mt-5 d-flex flex-column justify-content-center align-items-center"><img src={info} width={30} /><small className="ms-1 mt-2 text-muted text-uppercase">Não há registros para exibir!</small></span>
      }
      pagination
      subHeader
      progressPending={loading}
      subHeaderComponent={subHeaderComponent}
    />
  )
}

export default Datatable;

Datatable.propTypes = {
  data: PropsTypes.array.isRequired,
  columns: PropsTypes.array.isRequired,
  update: PropsTypes.func.isRequired,
  delete: PropsTypes.func.isRequired,
  create: PropsTypes.string.isRequired,
  loading: PropsTypes.bool.isRequired
}

Datatable.defaultProps = {
  loading: false,
};